module.exports = __webpack_public_path__ + "static/media/leftImg.b78498e4.svg";